import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

type ReturnType = [URLSearchParams, (params: URLSearchParams) => void];

export const useSearchParams = (): ReturnType => {
  const { search, pathname } = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const setSearchParams = useCallback(
    (params: URLSearchParams) => {
      history.replace({ pathname, search: params.toString() });
    },
    [history, pathname],
  );

  return [searchParams, setSearchParams];
};
